import { Injectable } from '@angular/core';

@Injectable()
export class RouterService {

  routerParent: string ="";
  routerParent01: string = "";
  routerParent02: string = "";
  route: string[]=[];

  public putRouter(router) {
    this.routerParent = router;
  }
  public putRouter01(router) {
    this.routerParent01 = router;
  }
  public putRouter02(router) {
    this.routerParent02 = router;
  }

  public putRoute(PRoute: string) {
    this.route.push(PRoute);
  }

  getBackRoute() {
    let _route = "home";
    try {
      if (this.route.length >= 1) {
        _route = this.route[this.route.length - 1];
        this.route.pop();
      }
    }
    catch (e) {
      _route = "home";
    }
    return _route;
  }

  //getBackRouteV2() {
  //  let _route = "home";
  //  try {
  //    if (this.route.length >= 1) {
  //      this.route.pop();
  //      if (this.route.length >= 1)
  //        _route = this.route[this.route.length - 1];
  //      else
  //        _route = "home";
  //    }
  //  }
  //  catch (e) {
  //    _route = "home";
  //    //console.log("Error");
  //  }
  //  return _route;
  //}
  
}
